<template>
  <LogoIcon
    v-if="variant === 'icon'"
    viewBox="0 0 800 800"
    :width="height"
    :height="height"
    class="inline-block"
  />
  <Logo v-if="variant === 'full'" :height="height" />
</template>

<script setup lang="ts">
import LogoIcon from './logo_icon.svg?component';
import Logo from './logo.svg?component';
withDefaults(defineProps<{ variant?: 'icon' | 'full'; height?: string }>(), {
  variant: 'icon',
  height: '36',
});
</script>
